export const LANGUAGE_MAP = {
  ru: 'Русский', // Russian
  id: 'Indonesian', // Indonesian
  en: 'English', // English
  es: 'Español', // Spanish
  de: 'Deutsch', // German
  fr: 'Français', // French
  hi: 'हिंदी', // Hindi
  hu: 'Magyar', // Hungarian
  it: 'Italiano', // Italian
  th: 'ภาษาไทย', // Thai
  ro: 'Română', // Romanian
  ko: '한국어', // Korean
  pl: 'Polski', // Polish
  pt: 'Português', // Portuguese
  tr: 'Türkçe', // Turkish
  ja: '日本語', // Japanese
  bg: 'Български', // Bulgarian
};
